import { Injectable, OnDestroy } from '@angular/core';
import { Observable, Subject, of } from 'rxjs';
import { ClientConfiguration, SpecificFields } from '../../clients/models/client.model';
import { ClientService } from '../client.service';
import { shareReplay, switchMap, takeUntil } from 'rxjs/operators';
import { BO_API_KEY } from '../../shared/constants/constant';

@Injectable({
  providedIn: 'root',
})
export class SharedClientConfigurationService implements OnDestroy {
  specificFields$: Observable<SpecificFields>;
  destroy$ = new Subject<void>();
  constructor(private clientService: ClientService) {
    this.specificFields$ = this.loadSpecificFields(BO_API_KEY, 'fr', 'FR').pipe(shareReplay(1));
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private loadSpecificFields(apiKey: string, lang: string, country: string): Observable<SpecificFields> {
    return this.clientService.getClientByApiKey(apiKey, lang, country).pipe(
      takeUntil(this.destroy$),
      switchMap((boClient: ClientConfiguration) => of(boClient.markets[0]?.specificFields as SpecificFields))
    );
  }
}
